// React
import React from "react";
// Framework
import { Skeleton } from "ui/components";

const Loader = () => <Skeleton variant="rect" width="100%" height="100%" />;

export default Loader;
